import React from 'react'
import { Link } from "react-router-dom";
import HomeBlog from '../home/HomeBlog';


const Blog = () => {
    return (
        <>
            <div className="site-breadcrumb" style={{ background: 'url(assets/yog/0101.webp)' }}>
                <div className="container">
                    <h2 className="breadcrumb-title">Our Blog</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link to="/">Home</Link></li>
                        <li className="active">Our Blog</li>
                    </ul>
                </div>
            </div>

            <HomeBlog />
        </>
    )
}

export default Blog